import { generateUtilityClass, generateUtilityClasses } from "@mui/material";
const sectionName = "TidalSection";
function getSectionUtilityClass(slot) {
  return generateUtilityClass(sectionName, slot);
}
const sectionClasses = generateUtilityClasses(sectionName, [
  "root",
  "pinnedTop",
  "divider",
  "pinned",
  "content",
  "header",
  "loadMore"
]);
export {
  getSectionUtilityClass,
  sectionClasses,
  sectionName
};
//# sourceMappingURL=classes.js.map
